<template></template>
<script>
import {setCookie} from "tiny-cookie";
import {PhpHelper} from "../helpers/PhpHelper";
import UserApi from "../api/UserApi";
export default {
    name: "PartnerCookie",
    data() {
        return {
            cookieName: 'partnrs',
            cookieExpiresMonth: 6,
            parameterName: 'p',
        }
    },
    mounted() {
        this.setPartnerCookie();
        this.setPartnerMove();
        document.addEventListener("DOMContentLoaded", () => this.removePartnerFromUrl());
    },
    methods: {
        // срок жизни партнёрской куки без moment
        getPartnerCookieExpires() {
            const expires = new Date();
            expires.setMonth(expires.getMonth() + this.cookieExpiresMonth);
            return expires.toISOString();
        },
        // проставляем партнерскую куку
        setPartnerCookie() {
            let params = new URLSearchParams(window.location.search);
            setCookie(
                this.cookieName,
                PhpHelper.serialize({
                    pid: params.get(this.parameterName),
                    time: PhpHelper.timestamp(Date.now()),
                    uri: window.location.pathname + window.location.search,
                    ref: document.referrer
                }),
                {
                    expires: this.getPartnerCookieExpires(),
                    domain: this.$config.PUBLIC_DOMAIN_COOKIES,
                }
            );
        },
        // пишем статистику переходов
        setPartnerMove() {
            let params = new URLSearchParams(window.location.search);
            UserApi.sendPartnerMoveStat({
                partnerId: params.get(this.parameterName),
                uri: window.location.pathname + window.location.search,
                ref: document.referrer,
            })
        },
        removePartnerFromUrl() {
            const url = new URL(document.location);
            const searchParams = url.searchParams;
            searchParams.delete(this.parameterName);
            history.pushState(null, null, url.toString());
        }
    }
}
</script>
